import { render, staticRenderFns } from "./ModalAbrirChamado.vue?vue&type=template&id=6f77ec99&scoped=true&"
import script from "./ModalAbrirChamado.vue?vue&type=script&lang=js&"
export * from "./ModalAbrirChamado.vue?vue&type=script&lang=js&"
import style0 from "./ModalAbrirChamado.vue?vue&type=style&index=0&id=6f77ec99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77ec99",
  null
  
)

export default component.exports